import { render } from "./DigitalClockView.vue?vue&type=template&id=13ed0634&scoped=true"
import script from "./DigitalClockView.vue?vue&type=script&lang=js"
export * from "./DigitalClockView.vue?vue&type=script&lang=js"

import "./DigitalClockView.vue?vue&type=style&index=0&id=13ed0634&scoped=true&lang=scss"

import exportComponent from "D:\\Code\\MonsterView\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ed0634"]])

export default __exports__